<template>
  <div id="app">
    <div id="nav">
      <div class="menu-icon" :class="active?'active':''" @click="toggleMenu">
        <span></span>
        <span></span>
         <span></span>
      </div>
      <div class="logo">
        <router-link to="/">
        <img src="./assets/logo@2x.png" alt="">
        </router-link>
      </div>
      <div class="header" :class="active?'active':''" >
        <ul>
          <li @click="toggleMenu">
            <router-link to="/" >
              products
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/awards">
              awards
            </router-link>
          </li>
          <li @click="toggleMenu">
            <router-link to="/about">
              about
            </router-link>
          </li>
        </ul>
      </div>
      <div class="social">
        <ul>
          <li>
            <a href="https://www.instagram.com/roci_design/" target="_blank">
                <img src="./assets/instagram.png" alt="instagram">
            </a>
          
          </li>
          <li>
            <a href="https://weibo.com/u/3672668710"  target="_blank">
              <img src="./assets/weibo.png" alt="weibo">
            </a>
          </li>
          <li>
           <a href="mailto:roci_v@rocidesign.com"  target="_blank">
              <img src="./assets/email.png" alt="email" >
           </a>
          </li>
        </ul>
      </div>
    </div>
    <div id="content">
      <transition name="fade">
        <router-view />
      </transition>
    </div>
   
  </div>
</template>
<script>
export default {
  name: 'App',
  data () {
    return {
      active:false
    }
  },
  methods:{
    toggleMenu(){
      this.active = !this.active
    }
  }
}
</script>
<style lang="less">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
